import React, { useEffect, useState } from "react";
import { useDropzone } from "react-dropzone";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import galleryIcon from "../../../src/assests/images/gallaryIcon.svg";
import Upload from "../../../src/assests/images/document-upload.svg";
import { getToken } from "../../utils/utils";
import { useNavigate } from "react-router-dom";
import { uploadimagetask } from "../../pages/create-task/api";
import { useTaskContext } from "../store/AlltasksContext";

// ✅ Type for uploaded/default images
type FileItem22 = {
  id: number;
  file?: File; // optional for default images
  preview: string;
  imageUrl: string;
};

function CreatetaskImgTwo({
  setuploadedImage,
  id,
  headTitle,
  title,
  subtitle,
  note,
  uploadText,
  maintitle,
  handleAction,
  uploadSize,
  addMoreText,
  onClick,
  imageUrls = [],
}: any) {
  const [keyVisualFiles, setKeyVisualFiles] = useState<FileItem22[]>([]);
  const [files2, setFiles2] = useState<FileItem22[]>([]);
  const [mainid, setmainid] = useState<number | null>(null);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadError, setUploadError] = useState<string | null>(null);

  const navigate = useNavigate();
  const token = getToken();

  const {
    setfileName,
    fileName,
    setfinalll,
    finalll,
    imagesdata1,
    setimagesdata1,
    Tabname,
    defaulttaskiconimages,
    setdefaulttaskiconimages,
  } = useTaskContext();

  // ✅ Initialize files2 with default images
  useEffect(() => {
    setimagesdata1([]); // clear images on tab change
    if (defaulttaskiconimages.length > 0) {
      const defaultFiles: FileItem22[] = defaulttaskiconimages.map((url, index) => ({
        id: index,
        preview: url,
        imageUrl: url,
      }));
      setFiles2(defaultFiles);
    }
  }, [Tabname, defaulttaskiconimages, setFiles2, setimagesdata1]);

  const handleDrop = async (
    acceptedFiles: File[],
    setter: React.Dispatch<React.SetStateAction<FileItem22[]>>,
    id: number
  ) => {
    if (acceptedFiles.length === 0 || mainid === null) return;
    setIsUploading(true);

    try {
      const uploadedFiles = await Promise.all(
        acceptedFiles.map(async (file) => {
          const formData = new FormData();
          formData.append("answer", file);

          const response = await uploadimagetask(formData, token);
          if (response?.data?.answer) {
            return {
              id,
              file,
              preview: URL.createObjectURL(file),
              imageUrl: response.data.answer,
            } as FileItem22;
          } else return null;
        })
      );

      // ✅ Filter out nulls
      const successfulUploads: FileItem22[] = uploadedFiles.filter(
        (file): file is FileItem22 => file !== null
      );

      // Update context state
   setimagesdata1((prevImagesData) => {
  const existingEntry = prevImagesData.find((entry) => entry.id === id);

  const validUploads = successfulUploads
    .map((file) => file.imageUrl)
    .filter((url) => url); // ✅ remove null/undefined/empty strings

  if (existingEntry) {
    return prevImagesData.map((entry) =>
      entry.id === id
        ? { ...entry, images: [...entry.images.filter((url) => url), ...validUploads] }
        : entry
    );
  } else {
    return [...prevImagesData, { id, images: validUploads }];
  }
});


      setter((prev) => [...prev, ...successfulUploads]);
    } catch (error) {
      console.error("Error uploading files:", error);
      setUploadError("Failed to upload files");
    } finally {
      setIsUploading(false);
    }
  };

  const handleRemoveFile = (index: number, setter: React.Dispatch<React.SetStateAction<FileItem22[]>>, mainid: number) => {
    setter((prev) => {
      const updatedFiles = prev.filter((_, i) => i !== index);

      setimagesdata1((prevImagesData) =>
        prevImagesData
          .map((entry) =>
            entry.id === mainid ? { ...entry, images: entry.images.filter((_, i) => i !== index) } : entry
          )
          .filter((entry) => entry.images.length > 0)
      );

      // ✅ Also remove from default images if it was a default
      // setdefaulttaskiconimages((prev) =>
      //   prev.filter((url) => url !== prev[index]?.imageUrl && url !== files2[index]?.imageUrl)
      // );

      return updatedFiles;
    });
  };

  const handleBoxClick = () => setmainid(id);

  const renderThumbnails = (files: FileItem22[], setter: React.Dispatch<React.SetStateAction<FileItem22[]>>, mainid: number) =>
   files
    .filter((file) => file && file.imageUrl) // ✅ remove null/undefined
    .map((file, index) => {
      const isVideo = file.file?.type?.startsWith("video") || false;
      return (
        <Box
          key={index}
          sx={{
            position: "relative",
            width: 100,
            height: 100,
            margin: 1,
            border: "1px solid #ccc",
            borderRadius: 2,
            overflow: "hidden",
          }}
        >
          {isVideo ? (
            <video src={file.preview} controls style={{ width: "100%", height: "100%", objectFit: "cover" }} />
          ) : (
            <img src={file.preview} alt="Preview" crossOrigin="anonymous" style={{ width: "100%", height: "100%", objectFit: "cover" }} />
          )}
          <Button
            size="small"
            variant="contained"
            color="error"
            sx={{
              position: "absolute",
              top: 5,
              right: 5,
              minWidth: 24,
              width: 24,
              height: 24,
              padding: 0,
              borderRadius: "50%",
            }}
            onClick={() => handleRemoveFile(index, setter, mainid)}
          >
            ×
          </Button>
        </Box>
      );
    });

  const fileValidator = (file: File) => {
    if (file.type.startsWith("image") && file.size > 5 * 1024 * 1024)
      return { code: "too-large", message: "Image size must not exceed 5MB" };
    if (file.type.startsWith("video") && file.size > 10 * 1024 * 1024)
      return { code: "too-large", message: "Video size must not exceed 10MB" };
    return null;
  };

  const { getRootProps: getRootPropsMain, getInputProps: getInputPropsMain } = useDropzone({
    onDrop: (files: File[], fileRejections: any[]) => {
      setUploadError(null);
      if (fileRejections.length > 0) {
        fileRejections.forEach((rej) => rej.errors[0]?.message && setUploadError(rej.errors[0].message));
        return;
      }
      if (files.length > 0) handleDrop(files, setFiles2, 1);
    },
    accept: { "image/*": [], "video/*": [] },
    multiple: false,
    validator: fileValidator,
  });
console.log(defaulttaskiconimages, "defaulttaskiconimagesdefaulttaskiconimagesww",imagesdata1)
useEffect(() => {
  setimagesdata1([]); // clear previous images

  if (defaulttaskiconimages.length > 0) {
    const defaultFiles: FileItem22[] = defaulttaskiconimages
      .filter((url) => url) // ✅ remove null/undefined
      .map((url, index) => ({
        id: index,
        preview: url,
        imageUrl: url,
      }));

    setFiles2(defaultFiles);

    setimagesdata1(
      defaultFiles.map((file) => ({
        id: file.id,
        images: [file.imageUrl],
      }))
    );
  }
}, [Tabname, defaulttaskiconimages, setFiles2, setimagesdata1]);


  return (
    <Box sx={{ display: "flex", flexDirection: "column", padding: "0 0px" }}>
      <Typography variant="h3" sx={{ fontSize: "24px", fontWeight: "600", color: "#000", margin: "20px 0 20px" }}>
        {headTitle}
      </Typography>
      <Typography variant="h6" sx={{ fontSize: "18px", display: "flex" }}>
        <img style={{ marginRight: "8px", marginTop: "0px" }} src={Upload} alt="upload image" />
        {title}
      </Typography>
      <Typography variant="body1" sx={{ fontSize: "16px", fontWeight: "400", color: "#696A6B" }}>
        {subtitle}
      </Typography>

      <Box sx={{ display: "flex" }}>
        <Box
          {...getRootPropsMain({ onClick: handleBoxClick })}
          sx={{
            mt: 2,
            border: "2px dashed #ccc",
            padding: 3,
            borderRadius: 2,
            textAlign: "center",
            cursor: "pointer",
            height: "200px",
            background: "#fff",
            paddingTop: "40px",
            width: "70%",
            marginRight: "30px",
          }}
        >
          <input {...getInputPropsMain()} />
          <img src={galleryIcon} alt="Gallery Icon" />
          <Typography sx={{ fontSize: "16px" }}>{uploadText}</Typography>
          <Typography sx={{ fontSize: "14px", color: "#7D7E7F" }}>{uploadSize}</Typography>
        </Box>
      </Box>

      {uploadError && <Typography sx={{ color: "red", mt: 1 }}>{uploadError}</Typography>}

      <Box onClick={() => handleAction && handleAction(id)} sx={{ display: "flex", mt: 2, flexWrap: "wrap" }}>
        {renderThumbnails(files2, setFiles2, mainid || 0)}
      </Box>

      <Typography variant="body1" sx={{ display: "flex" }}>
 {imageUrls.length > 0
          ? imageUrls.map((url: any, index: any) => (
              <img key={index} src={url} alt={`Image ${index + 1}`} className="uploaded-image-preview" />
            ))
          : null}
                  {note}
      </Typography>
    </Box>
  );
}

export default CreatetaskImgTwo;